import { useScrollEdges } from '@/hooks/useScrollEdges';
import { cn } from '@/lib/utils';

interface HorizontalScrollFadeProps {
    container: HTMLElement | null;
    contentVersions?: unknown[];
    className?: string;
}

export function HorizontalScrollFade({
    container,
    contentVersions = [],
    className,
}: HorizontalScrollFadeProps) {
    const { atStart, atEnd } = useScrollEdges(container, ...contentVersions);

    if (atStart && atEnd) return null;

    return (
        <>
            {!atStart && (
                <div
                    aria-hidden
                    className={cn(
                        'pointer-events-none absolute inset-y-0 left-0 w-6 bg-gradient-to-r',
                        className,
                    )}
                />
            )}
            {!atEnd && (
                <div
                    aria-hidden
                    className={cn(
                        'pointer-events-none absolute inset-y-0 right-0 w-6 bg-gradient-to-l',
                        className,
                    )}
                />
            )}
        </>
    );
}
